module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/input-currency-readonly/input-currency-readonly.component.scss
// module id = ./src/app/components/tools/input-currency-readonly/input-currency-readonly.component.scss
// module chunks = main